
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M29.485 38.337c-.27 0-.52-.11-.71-.29L16.407 25.734a.988.988 0 010-1.404.999.999 0 011.41 0l11.668 11.618L41.183 24.3a.999.999 0 011.41 0 .988.988 0 010 1.404L30.195 38.048a.992.992 0 01-.71.289z"}}),_c('path',{attrs:{"d":"M29.505 52.713c-12.408 0-22.497-10.046-22.497-22.4 0-12.356 10.089-22.401 22.497-22.401S52 17.957 52 30.312c0 12.355-10.088 22.4-22.496 22.4zm0-42.81c-11.298 0-20.497 9.16-20.497 20.41s9.199 20.409 20.497 20.409 20.497-9.16 20.497-20.41S40.803 9.903 29.505 9.903z"}})])
          )
        }
      }
    